//
// Copyright (c) 2025 Comcast
//

import PropTypes from 'prop-types'
import { Field } from 'react-final-form'
import styled, { css } from 'styled-components'
import SelectAsync from 'components/Shared/SelectAsync/Index'
import { customIsEqual } from './utils'

const StyledSelectAsync = styled(SelectAsync)`
  ${props => !props.multiselect && css`
    margin-right: 80px;
  `}
`

const PORTAL_Z_INDEX = 10001

// set allowNull=true as without it SelectAsync gets value="" and shows warning
const SelectAsyncField = ({
  name, placeholder, disabled, validate, isInModal,
  onLoadOptions, isMultiselect, isLoading,
}) => {
  return (
    <Field
      name={name}
      isEqual={customIsEqual}
      validate={validate}
      allowNull
    >
      {({ input, meta }) => {
        return (
          <StyledSelectAsync
            multiselect={isMultiselect}
            value={input.value || (isMultiselect ? [] : null)}
            onChange={input.onChange}
            onLoadOptions={onLoadOptions}
            placeholder={placeholder}
            usePortal={isInModal ? true : undefined}
            portalZindex={isInModal ? PORTAL_Z_INDEX : undefined}
            disabled={disabled}
            isLoading={isLoading}
          />
        )
      }}
    </Field>
  )
}

SelectAsyncField.propTypes = {
  name: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  validate: PropTypes.func,
  isInModal: PropTypes.bool,
  onLoadOptions: PropTypes.func,
  isMultiselect: PropTypes.bool,
  isLoading: PropTypes.bool,
}

export default SelectAsyncField
